import { Injectable } from "@angular/core";
import { Headers, Http,Request, RequestOptionsArgs,RequestOptions } from "@angular/http";
import { Authenticator } from "./authenticator";
import { DacConfig } from "./dac-config.service";
import { Pako } from "./pako.service";

import 'rxjs/add/operator/toPromise';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class HTTPService {
    private _httpStatusSubject:BehaviorSubject<number>;

    constructor(
        private _$http:Http,
        private _authenticator:Authenticator,
        private _dacConfig:DacConfig,
        private _pako:Pako // needs to be Pako
    ) {
        this._httpStatusSubject = new BehaviorSubject<number>(200);
    }

    public generateUrl(path:string, addToken:boolean = false) {
        // TODO: stephen I think this will have an error if the path already contained a query parameter... 
        // we need to find a better way to do this.
        let url = this._dacConfig.api_url + path;
        if (addToken) {
            url += "?token=" + this._authenticator.AuthenticationToken;
        }
        return url;
    }

    /**
     * Returns an observable that sends the most recent http status code
     */
    public currentStatus() : Observable<number> {
        return this._httpStatusSubject.asObservable();
    }

    public get(url:string, data?:any) : Promise<any> {
        if (!data) {
            data = {};
        }
        
        data.token = this._authenticator.AuthenticationToken;
        // IE 11 aggressively caches when we really don't want it to.  We fix it by introducing a cache busting solution...
        // Even though a server side header should solve this, it appears that IE11 doesn't always respect that.
        // so we lose the advantage of caching a number of get requests... but from an API we really want the most current result set
        data.cacheBuster = new Date().getTime(); 
        let options = new RequestOptions({params: data, withCredentials:true});
        return this._$http.get(this.generateUrl(url), options).toPromise()
        .then((val) => {
            if (val && val.status) {
                this._httpStatusSubject.next(val.status);
            }
            return val;
        })
        .catch((error) => {
            if (error && error.status) {
                this._httpStatusSubject.next(error.status);
            }
            throw error;
        });
    }
    
    public post(url, data) : Promise<any> {
        data.token = this._authenticator.AuthenticationToken;
        let options = new RequestOptions({withCredentials:true});        
        return this.postWithOptions(url, data, options);
    }

    public securePost(url, data, securityToken) : Promise<any> {
        // note the authentication token is different then the JWT token
        // TODO: stephen we need to look at changing this token to be a JWT.
        data.token = this._authenticator.AuthenticationToken;
        let headers:Headers = new Headers();
        headers.set("Authorization", "Bearer " + securityToken);
        let options = new RequestOptions({withCredentials:true, headers: headers});
        return this.postWithOptions(url, data, options);
    }

    private postWithOptions(url, data, options:RequestOptions) {
        console.log("token is: ", data.token);
        return this._$http.post(this.generateUrl(url), data, options)
        .toPromise()
        .then((val) => {
            if (val && val.status) {
                this._httpStatusSubject.next(val.status);
            }
            return val;
        })
        .catch((error) => {
            if (error && error.status) {
                this._httpStatusSubject.next(error.status);
            }
            throw error;
        });
    }

    public delete(url, data?:any) : Promise<any> {
        data = data || {};
        data.token = this._authenticator.AuthenticationToken;
        let options = new RequestOptions({withCredentials:true, params: data});
        return this._$http.delete(this.generateUrl(url), options)
        .toPromise()
        .then((val) => {
            if (val && val.status) {
                this._httpStatusSubject.next(val.status);
            }
            return val;
        })
        .catch((error) => {
            if (error && error.status) {
                this._httpStatusSubject.next(error.status);
            }
            throw error;
        });
    }
    
    public compressedPost(url, data, responseType:XMLHttpRequestResponseType = 'json') : Promise<any> {
        data.token = this._authenticator.AuthenticationToken;
        var binaryData:Uint8Array = this._pako.gzip(JSON.stringify(data));
       let postUrl = this.generateUrl(url);
        return new Promise((resolve, reject) => {
            var http = new XMLHttpRequest();
            http.withCredentials = true; // make sure to send http cookies.
            http.onload = () => {
                this._httpStatusSubject.next(http.status);
                if (http.status >= 200 && http.status < 300) {
                    resolve(http.response);
                } else {
                    reject({
                    status: http.status,
                    statusText: http.statusText,
                    response: http.response
                    });
                }
            };
            http.onerror = () => {
                this._httpStatusSubject.next(http.status);
                reject({
                    status: http.status,
                    statusText: http.statusText,
                    response: http.response
                });
            };
            http.open("POST", postUrl);
            http.setRequestHeader("Content-Type", "application/json");
            http.setRequestHeader("Content-Encoding", "gzip");
            http.responseType = responseType;

            http.send(binaryData);            
        });
        // TODO: stephen pako returns a Uint8Array and angular2 doesn't seem to know how to handle this
        // as it attempts to treat it as a string, angular1 handled this just fine... until we have a solution here
        // we'll leave this commented out.

        // // var binaryData:ArrayBuffer = this._pako.gzip(JSON.stringify(data)).buffer;
        // var binaryData:Blob = new Blob([this._pako.gzip(JSON.stringify(data))]);
		
        // var headers = new Headers();
        // headers.append("Content-Type", "application/json");
        // headers.append("Content-Encoding", "gzip");
        // let optionArgs:RequestOptionsArgs = {
        //     headers: headers
        // };
        // return this._$http.post(this._dacConfig.api_url + url, binaryData, optionArgs).toPromise();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/http.service.ts